const brushes = [
    [[0, 0]],
    [[0, 0]],
    [
        [0, 0],
        [-5, -5],
        [-5, -3],
        [-5, -1],
        [-5, 1],
        [-5, 3],
        [-4, 0],
        [-3, -5],
        [-3, -3],
        [-3, -1],
        [-3, 1],
        [-3, 3],
        [-2, 0],
        [-3, -3],
        [-3, -2],
        [-3, -1],
        [-3, 0],
        [-3, 1],
        [-3, 2],
        [-2, -3],
        [-2, -2],
        [-2, -1],
        [-2, 0],
        [-2, 1],
        [-2, 2],
        [-1, -3],
        [-1, -2],
        [-1, -1],
        [-1, 0],
        [-1, 1],
        [-1, 2],
        [0, -3],
        [0, -2],
        [0, -1],
        [0, 1],
        [0, 2],
        [1, -3],
        [1, -2],
        [1, -1],
        [1, 0],
        [1, 1],
        [1, 2],
        [2, -3],
        [2, -2],
        [2, -1],
        [2, 0],
        [2, 1],
        [2, 2],
        [3, 0],
        [3, 1],
        [3, 2],
        [3, 3],
        [1, 1],
        [1, 3],
        [2, 0],
        [3, -5],
        [3, -3],
        [3, -1],
        [3, 1],
        [3, 3],
        [4, 0],
        [4, -5],
        [5, 0],
        [5, -5],
        [5, 5],
    ],
    [
        [0, 0],
        [-10, -10],
        [-10, -6],
        [-10, -2],
        [-10, 2],
        [-10, 6],
        [-6, -10],
        [-6, -6],
        [-6, -2],
        [-6, 2],
        [-6, 6],
        [-2, -10],
        [-2, -6],
        [-2, -2],
        [-3, -3],
        [-3, -2],
        [-3, -1],
        [-3, 0],
        [-3, 1],
        [-3, 2],
        [-2, -3],
        [-2, -2],
        [-2, -1],
        [-2, 0],
        [-2, 1],
        [-2, 2],
        [-1, -3],
        [-1, -2],
        [-1, -1],
        [-1, 0],
        [-1, 1],
        [-1, 2],
        [0, -3],
        [0, -2],
        [0, -1],
        [0, 1],
        [0, 2],
        [1, -3],
        [1, -2],
        [1, -1],
        [1, 0],
        [1, 1],
        [1, 2],
        [2, -3],
        [2, -2],
        [2, -1],
        [2, 0],
        [2, 1],
        [2, 2],
        [3, 0],
        [3, 1],
        [3, 2],
        [3, 3],
        [-2, 2],
        [-2, 6],
        [2, -10],
        [2, -6],
        [2, -2],
        [2, 2],
        [2, 6],
        [6, -10],
        [6, -6],
        [6, -2],
        [6, 2],
        [6, 6],
        [10, 10],
        [10, 0],
        [10, -10],
    ],
];

export default brushes;
